// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getFirestore} from "firebase/firestore";
import {getAuth, GoogleAuthProvider} from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCs9y7MPrMQ1xhapkTfHQ-JSPahCM3L87I",
  authDomain: "tabletop-encyclopedia.firebaseapp.com",
  projectId: "tabletop-encyclopedia",
  storageBucket: "tabletop-encyclopedia.appspot.com",
  messagingSenderId: "1033457570614",
  appId: "1:1033457570614:web:1527f787095326e09a9997",
  measurementId: "G-H4JGL2SL2Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);


export const db = getFirestore(app);
export const auth = getAuth(app)
export const provider = new GoogleAuthProvider();
